module.exports = __webpack_public_path__ + "img/ico-bell.ab824c0e.svg";